exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#embeddedWeb[data-v-298085ff]{width:100%!important;overflow-x:auto}#iframe[data-v-298085ff]{width:100%!important;border:none;height:100%;overflow-x:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-298085ff","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modular/menu/EmbeddedWeb.vue
// module id = 233
// module chunks = 0